import graphql from "babel-plugin-relay/macro";
import { commitMutation } from "react-relay";

const mutation = graphql`
  mutation RejectSystemDocumentTemplateMutation(
    $input: RejectSystemDocumentTemplateInput!
  ) {
    rejectSystemDocumentTemplate(input: $input) {
      ok
      redirectPath
      error
    }
  }
`;

function rejectSystemDocumentTemplate(
  environment,
  documentPk,
  comment,
  callback
) {
  const variables = {
    input: {
      document: documentPk,
      comment: comment
    }
  };

  commitMutation(environment, {
    mutation,
    variables,
    onCompleted: (response, errors) => callback(response, errors),
    onError: error => callback(null, error)
  });
}

export default rejectSystemDocumentTemplate;
